"use client";

import { sendGAEvent } from "@next/third-parties/google";

export function useTrackButtonClick(defaultCategory = "Engagement") {
  return (buttonName: string, extraParams: Record<string, any> = {}) => {
    sendGAEvent(
      "event",
      "button_click",
      {
        button_name: buttonName,
        button_category: defaultCategory,
        button_value: 1,
        ...extraParams,
      }
    );
  };
}